@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;



<ul [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <li>
        <a routerLink="/privacy">{{ 'policy.title' | translate }}</a>
    </li>
    <li>
        <a routerLink="/terms">{{ 'terms.title' | translate }}</a>
    </li>
</ul>
